declare global {
  interface Window {
    analytics?: SegmentAnalytics.AnalyticsJS;
    ga?: UniversalAnalytics.ga;
    dataLayer?: Record<string, any>[];
  }
}

export default function track(
  eventName: string,
  properties?: Record<string, any>
): void {
  if (typeof window === 'undefined') {
    console.error(
      'Cannot call `track` during server-side rendering. Must be called on the client only.'
    );
    return;
  }

  if (
    typeof window.analytics !== 'undefined' &&
    eventName &&
    eventName === 'Viewed Payment Form'
  ) {
    window.analytics.track(eventName, properties);
  }
}

export function trackGA(
  eventCategory: string,
  eventAction: string,
  eventLabel?: string,
  eventValue?: any,
  gaDimensions?: object
): void {
  if (typeof window === 'undefined') {
    return;
  }

  // GA
  if (typeof window.ga !== 'undefined') {
    window.ga('send', 'event', {
      eventCategory,
      eventAction,
      eventLabel,
      eventValue,
      ...gaDimensions,
    });
  }

  // GTM
  if (typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push({
      event: 'GAEvent',
      eventCategory,
      eventAction,
      eventLabel,
      eventValue,
      ...gaDimensions,
    });
  }
}
